import { createContext, PropsWithChildren, useCallback, useState } from 'react';

type HintProviderContextValue = {
  isAnyOpen: boolean;
  notifyOpen: () => void;
  notifyClose: () => void;
};

export const HintProviderContext = createContext<HintProviderContextValue>({
  isAnyOpen: false,
  notifyOpen: () => {},
  notifyClose: () => {},
});

export const HintProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [count, setCount] = useState<number>(0);

  const notifyOpen = useCallback(() => setCount((n) => n + 1), []);
  const notifyClose = useCallback(
    () => setCount((n) => Math.max(0, n - 1)),
    []
  );

  return (
    <HintProviderContext.Provider
      value={{
        isAnyOpen: count > 0,
        notifyOpen,
        notifyClose,
      }}
    >
      {children}
    </HintProviderContext.Provider>
  );
};
